import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { TargetDateBlock, TargetDateDelete, TargetDateText } from './styles'
import { showModal } from '../../../actions/_modal'
import { connect } from 'react-redux'
import colors from '../../../configuration/colors'
import { actionMyStudentsDeleteTargetDate } from '../../../actions/mystudents'
import { DotFlashing } from '../animation/DotsLoadingAnimation/DotsLoaderAnimation'

export class TargetDate extends Component {
  renderTargetDateLabel() {
    const { targetDate } = this.props

    if (targetDate) {
      if (targetDate.isFetching) {
        return (
          <TargetDateText>
            <DotFlashing />
          </TargetDateText>
        )
      }

      const now = moment()
      const target = moment(targetDate.target_on, 'YYYY-MM-DD')
      const diff = target.diff(now, 'd')
      if (diff >= 6) {
        return (
          <TargetDateText style={{ color: colors.dove, fontWeight: '300' }}>
            {target.format('D MMM')}
          </TargetDateText>
        )
      } else if (diff >= 0) {
        return (
          <TargetDateText style={{ color: colors.aluminum }}>
            {target.format('D MMM')}
          </TargetDateText>
        )
      } else {
        return (
          <TargetDateText style={{ color: colors.victoria }}>
            {target.format('D MMM')}
          </TargetDateText>
        )
      }
    } else {
      return (
        <TargetDateText style={{ color: colors.dove, fontWeight: '300' }}>
          -&nbsp;-&nbsp;&nbsp;-&nbsp;-&nbsp;-
        </TargetDateText>
      )
    }
  }

  onBlockClick() {
    const { quest, studentId, courseSectionId, targetDate } = this.props

    this.props.dispatch(
      showModal('UPDATE_TARGET_DATE', {
        studentId,
        quest,
        courseSectionId,
        targetDate
      })
    )
  }

  async onDeleteClick(e) {
    const { dispatch, targetDate, studentId } = this.props

    e.stopPropagation()

    dispatch(actionMyStudentsDeleteTargetDate(targetDate.id, studentId))
  }

  render() {
    const { targetDate } = this.props

    return (
      <TargetDateBlock onClick={this.onBlockClick.bind(this)}>
        {this.renderTargetDateLabel()}
        {targetDate && (
          <TargetDateDelete onClick={this.onDeleteClick.bind(this)} />
        )}
      </TargetDateBlock>
    )
  }
}

TargetDate.propTypes = {
  dispatch: PropTypes.func.isRequired,
  targetDate: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  studentId: PropTypes.number.isRequired,
  courseSectionId: PropTypes.number.isRequired,
  orgId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired
}

export function mapStateToProps(state) {
  return {
    orgId: state.organization.orgId,
    token: state.auth.token
  }
}

export default connect(mapStateToProps)(TargetDate)
